import React, { FC } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { TimePickerStyled, Wrapper } from './styles';
import { TimePickerProps } from './modules';
import { renderMultiSectionDigitalClockTimeView } from '@mui/x-date-pickers';

/**
 * TimePicker component.
 *
 * This component allows users to select a time value using a digital clock
 * interface. It supports various configuration options such as default and
 * current values, minimum and maximum times, disabled state, error handling,
 * and customizable time steps.
 */
const TimePicker: FC<TimePickerProps> = ({
  defaultValue,
  value,
  onChange,
  minTime,
  maxTime,
  disabled,
  isError,
  disableIgnoringDatePartForTimeValidation = true,
  timeStepsMinutes,
  onOpen,
}) => {
  /**
   * handleChange method.
   *
   * This method is called when the user selects a new time value in the
   * TimePicker component. It updates the current time value and calls the
   * onChange callback with the new time as an argument.
   */
  const handleChange = (value: Dayjs) => {
    const time = value ? dayjs(value).toDate() : '';
    onChange(time as any);
  };

  return (
    <Wrapper isError={isError}>
      <TimePickerStyled
        ampm={false}
        disabled={disabled}
        defaultValue={defaultValue}
        value={value}
        minTime={minTime}
        maxTime={maxTime}
        onChange={(value) => handleChange(value as Dayjs)}
        disableIgnoringDatePartForTimeValidation={
          disableIgnoringDatePartForTimeValidation
        }
        closeOnSelect={false}
        timeSteps={{ minutes: timeStepsMinutes || 5 }}
        onOpen={onOpen}
        viewRenderers={{
          hours: renderMultiSectionDigitalClockTimeView,
          minutes: renderMultiSectionDigitalClockTimeView,
          seconds: renderMultiSectionDigitalClockTimeView,
        }}
        slotProps={{ toolbar: { hidden: true } }}
      />
    </Wrapper>
  );
};

export default TimePicker;
